<template>
  <li
    class="menu-item"
    :class="{ 'is-hovered': hovered, 'is-hovered-multi': hovered && multi  }"
    @click="$emit('onClick', result)"
    @mouseover="hovered = true"
    @mouseout="hovered = false"
    tabindex="0"
    @keydown.enter.exact="$emit('valueSelected', result)"
    @keydown.space.exact="handleSpaceKeydown(result, $event)"
  >
    <div class="is-flex select-row">
      <input
        v-if="multi"
        type="checkbox"
        :checked="isActive"
        :aria-label="value"
      >
      <div
        class="is-flex flex-direction--column label select-row-label"
        style="align-items: flex-start"
      >
        <div
          v-html="value"
          style="white-space: nowrap"
          aria-hidden="true"
        >
        </div>
        <div
          v-if="subValueTplFn"
          v-html="subValueTplFn"
          :class="{
            'has-text-grey': !hovered,
          }"
        >
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
    multi: Boolean,
    result: Object,
    subValueTplFn: String,
    value: String,
    isHovered: Boolean,
  },
  data() {
    return {
      hovered: false,
    };
  },
  watch: {
    isHovered(active) {
      this.hovered = active;
    },
  },
  mounted() {
    this.hovered = this.isHovered;
  },
  methods: {
    handleSpaceKeydown(result, evt) {
      /* prevent scrolling inside ul */
      evt.preventDefault();
      this.$emit('valueSelected', result);
    },
  },
};
</script>

<style lang="sass" scoped>
  .select-row-label div
    overflow-wrap: break-word
    white-space: normal
    word-break: break-all
  [type="checkbox"]:not(:checked), [type="checkbox"]:checked
    position: absolute
    left: -9999px

  [type="checkbox"]:not(:checked) + .label, [type="checkbox"]:checked + .label
    position: relative
    padding-left: 1.95em
    cursor: pointer
  [type="checkbox"]:not(:checked) + .label:before
    content: ''
    position: absolute
    left: 0; top: 0
    width: 1.25em; height: 1.25em
    border: 1px solid #ccc
    background: #fff
    border-radius: 4px
    // box-shadow: inset 0 1px 3px rgba(0,0,0,.1)

  [type="checkbox"]:checked + .label:before
    content: ''
    position: absolute
    left: 0; top: 0
    width: 1.25em; height: 1.25em
    border: 1px solid #ccc
    background: #5953A4
    border-radius: 4px
    // box-shadow: inset 0 1px 3px rgba(0,0,0,.1)

  [type="checkbox"]:checked + .label:after
    content: '\2713'
    position: absolute
    top: .70em; left: .5em
    font-size: .75em
    line-height: 0.5
    color: #fff
    transition: all .2s
    font-family: 'Lucida Sans Unicode', 'Arial Unicode MS', Arial

  [type="checkbox"]:not(:checked) + .label:after
    opacity: 0
    transform: scale(0)

  [type="checkbox"]:checked + .label:after
    opacity: 1
    transform: scale(1)

  [type="checkbox"]:checked:focus + .label:before
    border: 1px solid #bbb !important

  [type="checkbox"]:not(:checked):focus + .label:before
    border: 1px solid #bbb !important

  /* hover style just for information */
  .label:hover:before,
  .is-hovered-multi .label:before
    border: 2px solid #4778d9!important
  .menu-item
    padding: 0 0.5rem
    margin-bottom: 2px
    font-size: 12px
    outline: none
    &:last-child
      margin-bottom: 0
  .is-hovered:not(.is-hovered-multi)
    background-color: #5953a4
    .label
      color: #fff
      font-weight: 550
  .is-hovered
    outline: none
</style>
